// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__1EJP9","form-field":"Form_form-field__3d-sZ","checkbox":"Form_checkbox__RKlvX"};